import Analytics from "analytics/util/Analytics";
import sourceFromPathname from "analytics/util/source";

export function selectedOptionOnNavBarEvent(destination, sourceParam) {
	const source = sourceParam || sourceFromPathname();

	Analytics.logUIEvent(Analytics.eventNames.selectedOptionOnNavBar, {
		data: {
			destination,
			source,
		},
	});
}

export function selectedFirstPartyPromoEvent(product) {
	Analytics.logUIEvent(Analytics.eventNames.selectedFirstPartyPromo, {
		data: {
			"promo id": `${product}.desktopnavbar`,
			source: "desktop navbar",
			action: "clicked on desktop navbar",
			"clicked on cta": true,
			interaction: "click",
		},
	});
}

export function viewedFirstPartyPromoEvent() {
	Analytics.logUIEvent(
		Analytics.eventNames.viewedFirstPartyPromo,
		{
			data: {
				"promo id": "boost.boostagain",
				"came from": "boost.boostagain",
				source: sourceFromPathname(),
				"is upsell": true,
			},
		},
	);
}



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/util/analytics.js